

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PatientToothChartParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientToothChart {

  //regId: string,
  visitId: number,
  toothId: number,
  columnId: number,
  colorValue: string,
  notes: string,
  tenantId: string;
  branchId: string;
  parameters?: PatientToothChartParameter[];
  links?: any;
  //Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
}

export interface PatientToothChartHeader {

  regId: string,
  visitId: number,
  toothId: number,
  notes: string,
 
  tenantId: string;
  branchId: string;
  missingTeeth: string;
  parameters?: PatientToothChartParameter[];
  links?: any;
  //Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
}

export abstract class PatientToothChartData {
  abstract list(url: string): Observable<PatientToothChart[]>;
  abstract create(url: string, data: PatientToothChart[]): Observable<any>;
  abstract createHeader(url: string, data: PatientToothChartHeader): Observable<any>;
  abstract update(url: string, data: PatientToothChartHeader): Observable<any>;
  abstract updatedtl(url: string, data: PatientToothChart): Observable<any>;
  abstract toothPrintList(url: string): Observable<any[]>;

  abstract delete(url: string): Observable<any>;
}
